import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {
  Paper, Typography, Stack, TextField, Button, Card, CardContent, Grid, MenuItem, Select, InputLabel, FormControl, Box, Divider
} from '@mui/material';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import DiscountIcon from '@mui/icons-material/Discount';
import WarningIcon from '@mui/icons-material/Warning';
import ReactApexChart from 'react-apexcharts';
import { fetchCurrencySetting } from '../utils/fetchCurrencySetting';
import CashierTransactionsDialog from './CashierTransactionsDialog';
import CustomerTransactionsDialog from './CustomerTransactionsDialog';








const Reports = () => {
  // Dialog state for customer transactions
  const [customerDialogOpen, setCustomerDialogOpen] = useState(false);
  const [customerDialogLoading, setCustomerDialogLoading] = useState(false);
  const [customerDialogTransactions, setCustomerDialogTransactions] = useState([]);
  const [customerDialogCustomer, setCustomerDialogCustomer] = useState('');

  // Handler to open dialog and fetch transactions for customer
  const handleShowCustomerTransactions = async (customerId, customerName) => {
    setCustomerDialogOpen(true);
    setCustomerDialogLoading(true);
    setCustomerDialogCustomer(customerName || 'Unknown');
    try {
      const params = [];
      if (from) params.push(`from=${from}`);
      if (to) params.push(`to=${to}`);
      const res = await fetch(`/api/sales/by-customer/${customerId}${params.length ? '?' + params.join('&') : ''}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('posUser') ? JSON.parse(localStorage.getItem('posUser')).token : ''}` }
      });
      if (!res.ok) throw new Error('Failed to fetch');
      const data = await res.json();
      setCustomerDialogTransactions(data);
    } catch (err) {
      setCustomerDialogTransactions([]);
    } finally {
      setCustomerDialogLoading(false);
    }
  };

  // Customer-wise report state
  const [customerData, setCustomerData] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);

  // Fetch customer-wise data
  const fetchCustomerWise = async () => {
    setCustomerLoading(true);
    try {
      const params = [];
      if (from) params.push(`from=${from}`);
      if (to) params.push(`to=${to}`);
      const res = await fetch(`/api/reports/customer-wise${params.length ? '?' + params.join('&') : ''}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('posUser') ? JSON.parse(localStorage.getItem('posUser')).token : ''}` }
      });
      if (!res.ok) throw new Error('Failed to fetch');
      const data = await res.json();
      setCustomerData(data);
    } catch (err) {
      setCustomerData([]);
    } finally {
      setCustomerLoading(false);
    }
  };
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogLoading, setDialogLoading] = useState(false);
  const [dialogTransactions, setDialogTransactions] = useState([]);
  const [dialogCashier, setDialogCashier] = useState('');

  // Handler to open dialog and fetch transactions
  const handleShowTransactions = async (userId, username) => {
    setDialogOpen(true);
    setDialogLoading(true);
    setDialogCashier(username || 'Unknown');
    try {
      const params = [];
      if (from) params.push(`from=${from}`);
      if (to) params.push(`to=${to}`);
      const res = await fetch(`/api/sales/by-cashier/${userId}${params.length ? '?' + params.join('&') : ''}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('posUser') ? JSON.parse(localStorage.getItem('posUser')).token : ''}` }
      });
      if (!res.ok) throw new Error('Failed to fetch');
      const data = await res.json();
      setDialogTransactions(data);
    } catch (err) {
      setDialogTransactions([]);
    } finally {
      setDialogLoading(false);
    }
  };
  const [cashierData, setCashierData] = useState([]);
  const [cashierLoading, setCashierLoading] = useState(false);
  // Fetch cashier-wise data
  const fetchCashierWise = async () => {
    setCashierLoading(true);
    try {
      const params = [];
      if (from) params.push(`from=${from}`);
      if (to) params.push(`to=${to}`);
      const res = await fetch(`/api/reports/cashier-wise${params.length ? '?' + params.join('&') : ''}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('posUser') ? JSON.parse(localStorage.getItem('posUser')).token : ''}` }
      });
      if (!res.ok) throw new Error('Failed to fetch');
      const data = await res.json();
      setCashierData(data);
    } catch (err) {
      setCashierData([]);
    } finally {
      setCashierLoading(false);
    }
  };

  // Helper to get today's date range
  const getTodayRange = () => {
    const today = new Date();
    const d = today.toISOString().slice(0, 10);
    return {
      fromDate: d + 'T00:00:00',
      toDate: d + 'T23:59:59'
    };
  };

  const todayRange = getTodayRange();
  
  const [from, setFrom] = useState(todayRange.fromDate);
  const [to, setTo] = useState(todayRange.toDate);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [range, setRange] = useState('today');
  const [trendData, setTrendData] = useState({ categories: [], data: [] });
  const [trendLoading, setTrendLoading] = useState(false);
  const [discountData, setDiscountData] = useState(null);
  const [discountLoading, setDiscountLoading] = useState(false);
    const [currency, setCurrency] = useState('USD');

    // Fetch currency setting
    useEffect(() => {
      fetchCurrencySetting().then(setCurrency);
    }, []);

    // Fetch sales trend data
  const fetchTrend = async () => {
    setTrendLoading(true);
    try {
      const params = [];
      if (from) params.push(`from=${from}`);
      if (to) params.push(`to=${to}`);
      const res = await fetch(`/api/reports/sales-trend${params.length ? '?' + params.join('&') : ''}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('posUser') ? JSON.parse(localStorage.getItem('posUser')).token : ''}` }
      });
      if (!res.ok) throw new Error('Failed to fetch');
      const data = await res.json();
      setTrendData(data);
    } catch (err) {
      setTrendData({ categories: [], data: [] });
    } finally {
      setTrendLoading(false);
    }
  };

  // Fetch discount data
  const fetchDiscountData = async () => {
    setDiscountLoading(true);
    try {
      const params = [];
      if (from) params.push(`from=${from}`);
      if (to) params.push(`to=${to}`);
      const res = await fetch(`/api/reports/discount-summary${params.length ? '?' + params.join('&') : ''}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('posUser') ? JSON.parse(localStorage.getItem('posUser')).token : ''}` }
      });
      if (!res.ok) throw new Error('Failed to fetch');
      const data = await res.json();
      console.log('Discount data received:', data);
      setDiscountData(data);
    } catch (err) {
      console.error('Error fetching discount data:', err);
      setDiscountData(null);
    } finally {
      setDiscountLoading(false);
    }
  };

  // Helper to get date range
  const getDateRange = (key) => {
    const today = new Date();
    let fromDate = '', toDate = '';
    if (key === 'today') {
      // Set fromDate to today 00:00:00 and toDate to today 23:59:59
      const d = today.toISOString().slice(0, 10);
      fromDate = d + 'T00:00:00';
      toDate = d + 'T23:59:59';
    } else if (key === 'last7') {
      const d = new Date(today); d.setDate(today.getDate() - 6);
      fromDate = d.toISOString().slice(0, 10);
      toDate = today.toISOString().slice(0, 10);
    } else if (key === 'last30') {
      const d = new Date(today); d.setDate(today.getDate() - 29);
      fromDate = d.toISOString().slice(0, 10);
      toDate = today.toISOString().slice(0, 10);
    } else if (key === 'thisYear') {
      fromDate = `${today.getFullYear()}-01-01`;
      toDate = today.toISOString().slice(0, 10);
    }
    return { fromDate, toDate };
  };

  useEffect(() => {
    if (range !== 'custom') {
      const { fromDate, toDate } = getDateRange(range);
      setFrom(fromDate);
      setTo(toDate);
    }
  }, [range]);

  const fetchSummary = async () => {
    setLoading(true);
    setError('');
    try {
      const params = [];
  if (from) params.push(`from=${from}`);
  if (to) params.push(`to=${to}`);
      const res = await fetch(`/api/reports/sales-summary${params.length ? '?' + params.join('&') : ''}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('posUser') ? JSON.parse(localStorage.getItem('posUser')).token : ''}` }
      });
      if (!res.ok) throw new Error('Failed to fetch');
      const data = await res.json();
      setSummary(data);
    } catch (err) {
      setError('Failed to fetch sales summary');
      setSummary(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  fetchSummary();
  fetchTrend();
  fetchCashierWise();
  fetchCustomerWise();
  fetchDiscountData();
    // eslint-disable-next-line
  }, [from, to]);

  // Calculate average sale
  const avgSale = summary && summary.totalSales ? summary.totalRevenue / summary.totalSales : 0;

  return (
    <Box sx={{ mt: 4 }}>
      <Paper sx={{ p: 3, mb: 3, boxShadow: 2 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems={{ xs: 'start', md: 'center' }} spacing={2}>
          <Box>
            <Typography variant="h5" fontWeight={700} mb={0.5}>Sales Reports</Typography>
            <Typography variant="body2" color="text.secondary">Analyze your store's performance and make data-driven decisions</Typography>
          </Box>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
            <FormControl size="small">
              <InputLabel id="range-label">Range</InputLabel>
              <Select
                labelId="range-label"
                value={range}
                label="Range"
                onChange={e => setRange(e.target.value)}
                sx={{ minWidth: 140 }}
              >
                <MenuItem value="today">Today</MenuItem>
                <MenuItem value="last7">Last 7 days</MenuItem>
                <MenuItem value="last30">Last 30 days</MenuItem>
                <MenuItem value="thisYear">This year</MenuItem>
                <MenuItem value="custom">Custom range</MenuItem>
              </Select>
            </FormControl>
            {range === 'custom' && (
              <>
                <TextField
                  label="From"
                  type="date"
                  size="small"
                  value={from}
                  onChange={e => setFrom(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  label="To"
                  type="date"
                  size="small"
                  value={to}
                  onChange={e => setTo(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
                <Button variant="contained" onClick={fetchSummary} disabled={loading}>
                  {loading ? 'Loading...' : 'Show'}
                </Button>
              </>
            )}
          </Stack>
        </Stack>
      </Paper>
      {error && <Typography color="error" mb={2}>{error}</Typography>}
      {/* Summary cards row - move to top after Sales Reports header */}
      <Grid container spacing={3} mb={4}>
        <Grid item xs={12} md={3}>
          <Card sx={{ p: 2, borderLeft: '5px solid #4f46e5', boxShadow: 1 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="body2" color="text.secondary">Total Sales</Typography>
                <Typography variant="h5" fontWeight={700} color="text.primary">
            {summary?.totalRevenue?.toLocaleString(undefined, { style: 'currency', currency }) || (0).toLocaleString(undefined, { style: 'currency', currency })}
                </Typography>
              </Box>
              <Box sx={{ p: 1.5, bgcolor: '#e3e8fd', borderRadius: '50%' }}>
                <PaymentsIcon color="primary" />
              </Box>
            </Stack>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card sx={{ p: 2, borderLeft: '5px solid #22c55e', boxShadow: 1 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="body2" color="text.secondary">Total Transactions</Typography>
                <Typography variant="h5" fontWeight={700} color="text.primary">
                  {summary?.totalSales || 0}
                </Typography>
              </Box>
              <Box sx={{ p: 1.5, bgcolor: '#d1fae5', borderRadius: '50%' }}>
                <ReceiptLongIcon sx={{ color: '#22c55e' }} />
              </Box>
            </Stack>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card sx={{ p: 2, borderLeft: '5px solid #a855f7', boxShadow: 1 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="body2" color="text.secondary">Average Sale</Typography>
                <Typography variant="h5" fontWeight={700} color="text.primary">
            {avgSale?.toLocaleString(undefined, { style: 'currency', currency })}
                </Typography>
              </Box>
              <Box sx={{ p: 1.5, bgcolor: '#f3e8ff', borderRadius: '50%' }}>
                <ShoppingCartIcon sx={{ color: '#a855f7' }} />
              </Box>
            </Stack>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card sx={{ p: 2, borderLeft: '5px solid #f59e0b', boxShadow: 1 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="body2" color="text.secondary">Items Sold</Typography>
                <Typography variant="h5" fontWeight={700} color="text.primary">
                  {summary?.totalItems || 0}
                </Typography>
              </Box>
              <Box sx={{ p: 1.5, bgcolor: '#fef3c7', borderRadius: '50%' }}>
                <Inventory2Icon sx={{ color: '#f59e0b' }} />
              </Box>
            </Stack>
          </Card>
        </Grid>
      </Grid>

      {/* Discount Analytics Cards */}
      <Grid container spacing={3} mb={4}>
        <Grid item xs={12}>
          <Typography variant="h6" fontWeight={600} mb={2} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <DiscountIcon color="primary" />
            Discount & Loss Analytics
          </Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card sx={{ p: 2, borderLeft: '5px solid #ec4899', boxShadow: 1 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="body2" color="text.secondary">Total Discounts</Typography>
                <Typography variant="h5" fontWeight={700} color="text.primary">
                  {discountData?.totalDiscountAmount?.toLocaleString(undefined, { style: 'currency', currency }) || (0).toLocaleString(undefined, { style: 'currency', currency })}
                </Typography>
              </Box>
              <Box sx={{ p: 1.5, bgcolor: '#fce7f3', borderRadius: '50%' }}>
                <DiscountIcon sx={{ color: '#ec4899' }} />
              </Box>
            </Stack>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card sx={{ p: 2, borderLeft: '5px solid #10b981', boxShadow: 1 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="body2" color="text.secondary">Discounted Sales</Typography>
                <Typography variant="h5" fontWeight={700} color="text.primary">
                  {discountData?.discountedTransactions || 0}
                </Typography>
              </Box>
              <Box sx={{ p: 1.5, bgcolor: '#d1fae5', borderRadius: '50%' }}>
                <TrendingDownIcon sx={{ color: '#10b981' }} />
              </Box>
            </Stack>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card sx={{ p: 2, borderLeft: '5px solid #22c55e', boxShadow: 1 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="body2" color="text.secondary">Profitable Discounts</Typography>
                <Typography variant="h5" fontWeight={700} color="text.primary">
                  {discountData?.profitableDiscountAmount?.toLocaleString(undefined, { style: 'currency', currency }) || (0).toLocaleString(undefined, { style: 'currency', currency })}
                </Typography>
              </Box>
              <Box sx={{ p: 1.5, bgcolor: '#d1fae5', borderRadius: '50%' }}>
                <TrendingUpIcon sx={{ color: '#22c55e' }} />
              </Box>
            </Stack>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card sx={{ p: 2, borderLeft: '5px solid #ef4444', boxShadow: 1 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="body2" color="text.secondary">Loss Amount</Typography>
                <Typography variant="h5" fontWeight={700} color="text.primary">
                  {discountData?.totalLossAmount?.toLocaleString(undefined, { style: 'currency', currency }) || (0).toLocaleString(undefined, { style: 'currency', currency })}
                </Typography>
                <Typography variant="caption" color="error">
                  {discountData?.lossItems || 0} items sold below cost
                </Typography>
              </Box>
              <Box sx={{ p: 1.5, bgcolor: '#fee2e2', borderRadius: '50%' }}>
                <WarningIcon sx={{ color: '#ef4444' }} />
              </Box>
            </Stack>
          </Card>
        </Grid>
      </Grid>
  {/* Cashier wise report section */}
      <Grid container spacing={3} mb={4}>
        <Grid item xs={12}>
          <Paper sx={{ p: 3, mb: 3, boxShadow: 2 }}>
            <Typography variant="h6" fontWeight={600} mb={2}>Cashier Wise Report</Typography>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Cashier</TableCell>
                    <TableCell align="right">Total Sales</TableCell>
                    <TableCell align="right">Total Revenue</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cashierLoading ? (
                    <TableRow><TableCell colSpan={3}>Loading...</TableCell></TableRow>
                  ) : cashierData.length === 0 ? (
                    <TableRow><TableCell colSpan={3}>No data for selected range.</TableCell></TableRow>
                  ) : cashierData.map(row => (
                    <TableRow key={row.userId || row.username}>
                      <TableCell>{row.username || 'Unknown'}</TableCell>
                      <TableCell align="right">
                        {row.userId ? (
                          <span style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={() => handleShowTransactions(row.userId, row.username)}
                          >
                            {row.totalSales}
                          </span>
                        ) : row.totalSales}
                      </TableCell>
                      <TableCell align="right">{row.totalRevenue?.toLocaleString(undefined, { style: 'currency', currency })}</TableCell>
                    </TableRow>
                  ))}
      <CashierTransactionsDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        transactions={dialogTransactions}
        loading={dialogLoading}
        cashierName={dialogCashier}
      />
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>

      {/* Customer wise report section */}
      <Grid container spacing={3} mb={4}>
        <Grid item xs={12}>
          <Paper sx={{ p: 3, mb: 3, boxShadow: 2 }}>
            <Typography variant="h6" fontWeight={600} mb={2}>Customer Wise Report</Typography>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Customer</TableCell>
                    <TableCell align="right">Total Sales</TableCell>
                    <TableCell align="right">Total Revenue</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {customerLoading ? (
                    <TableRow><TableCell colSpan={3}>Loading...</TableCell></TableRow>
                  ) : customerData.length === 0 ? (
                    <TableRow><TableCell colSpan={3}>No data for selected range.</TableCell></TableRow>
                  ) : customerData.map(row => (
                    <TableRow key={row.customerId || row.customerName}>
                      <TableCell>{row.customerName || 'Unknown'}</TableCell>
                      <TableCell align="right">
                        {row.customerId ? (
                          <span style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={() => handleShowCustomerTransactions(row.customerId, row.customerName)}
                          >
                            {row.totalSales}
                          </span>
                        ) : row.totalSales}
                      </TableCell>
      <CustomerTransactionsDialog
        open={customerDialogOpen}
        onClose={() => setCustomerDialogOpen(false)}
        transactions={customerDialogTransactions}
        loading={customerDialogLoading}
        customerName={customerDialogCustomer}
      />
                      <TableCell align="right">{row.totalRevenue?.toLocaleString(undefined, { style: 'currency', currency })}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>

      {/* Product-wise Discount Analysis */}
      <Grid container spacing={3} mb={4}>
        <Grid item xs={12}>
          <Paper sx={{ p: 3, mb: 3, boxShadow: 2 }}>
            <Typography variant="h6" fontWeight={600} mb={2}>Product-wise Discount Analysis</Typography>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Item #</TableCell>
                    <TableCell>Product</TableCell>
                    <TableCell align="right">Times Discounted</TableCell>
                    <TableCell align="right">Quantity Sold</TableCell>
                    <TableCell align="right">Avg Discount %</TableCell>
                    <TableCell align="right">Total Discount</TableCell>
                    <TableCell align="right">Revenue After Discount</TableCell>
                    <TableCell align="center">Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {discountLoading ? (
                    <TableRow><TableCell colSpan={8}>Loading...</TableCell></TableRow>
                  ) : !discountData || !discountData.productDiscounts || discountData.productDiscounts.length === 0 ? (
                    <TableRow><TableCell colSpan={8}>No discounted products in selected range.</TableCell></TableRow>
                  ) : discountData.productDiscounts.map(row => (
                    <TableRow key={row.productId}>
                      <TableCell>{row.itemNumber || 'N/A'}</TableCell>
                      <TableCell sx={{ fontWeight: 500 }}>{row.productName}</TableCell>
                      <TableCell align="right">{row.timesDiscounted}</TableCell>
                      <TableCell align="right">{row.totalQuantity}</TableCell>
                      <TableCell align="right">{row.avgDiscountPercentage}%</TableCell>
                      <TableCell align="right" sx={{ color: '#ef4444', fontWeight: 600 }}>
                        -{row.totalDiscountAmount?.toLocaleString(undefined, { style: 'currency', currency })}
                      </TableCell>
                      <TableCell align="right" sx={{ fontWeight: 600 }}>
                        {row.totalRevenue?.toLocaleString(undefined, { style: 'currency', currency })}
                      </TableCell>
                      <TableCell align="center">
                        {row.isProfitable ? (
                          <Box sx={{ 
                            display: 'inline-block', 
                            px: 1.5, 
                            py: 0.5, 
                            bgcolor: '#dcfce7', 
                            color: '#16a34a', 
                            borderRadius: 1,
                            fontSize: '0.75rem',
                            fontWeight: 600
                          }}>
                            PROFIT
                          </Box>
                        ) : (
                          <Box sx={{ 
                            display: 'inline-block', 
                            px: 1.5, 
                            py: 0.5, 
                            bgcolor: '#fee2e2', 
                            color: '#dc2626', 
                            borderRadius: 1,
                            fontSize: '0.75rem',
                            fontWeight: 600
                          }}>
                            LOSS
                          </Box>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>
      {/* Duplicate summary cards removed as requested */}
      <Grid container spacing={3} mb={4}>
        <Grid item xs={12} md={8}>
          <Card sx={{ p: 3, minHeight: 340 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography fontWeight={600}>Sales Trend</Typography>
              <FormControl size="small">
                <Select value="daily" size="small" sx={{ minWidth: 100 }} disabled>
                  <MenuItem value="daily">Daily</MenuItem>
                  <MenuItem value="weekly">Weekly</MenuItem>
                  <MenuItem value="monthly">Monthly</MenuItem>
                </Select>
              </FormControl>
            </Stack>
            <Box sx={{ height: 260, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'text.secondary', border: '1px dashed #e0e0e0', borderRadius: 2 }}>
              {trendLoading ? (
                <Typography variant="body2">Loading chart...</Typography>
              ) : trendData.categories.length > 0 ? (
                <ReactApexChart
                  type="area"
                  height={240}
                  options={{
                    chart: { id: 'sales-trend', toolbar: { show: false } },
                    xaxis: { categories: trendData.categories, labels: { style: { colors: '#64748b' } } },
                    yaxis: { labels: { style: { colors: '#64748b' } } },
                    dataLabels: { enabled: false },
                    stroke: { curve: 'smooth', width: 2 },
                    fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.7, opacityTo: 0.1, stops: [0, 90, 100] } },
                    grid: { borderColor: '#f1f1f1' },
                    colors: ['#4f46e5'],
                  }}
                  series={[{ name: 'Sales', data: trendData.data }]}
                />
              ) : (
                <Typography variant="body2">No data for selected range.</Typography>
              )}
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ p: 3, minHeight: 340 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography fontWeight={600}>Payment Methods</Typography>
              <Button size="small" variant="text" disabled>More</Button>
            </Stack>
            <Box sx={{ height: 260, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'text.secondary', border: '1px dashed #e0e0e0', borderRadius: 2 }}>
              {/* Chart placeholder */}
              <Typography variant="body2">(Payment methods chart coming soon)</Typography>
            </Box>
          </Card>
        </Grid>
      </Grid>
      {/* More report sections can be added here */}
    </Box>
  );
};

export default Reports;
